import { SET_PLUGINS_LIST } from '../types/plugins'
import { getPluginsListAPI } from '../api/plugins'
import { addMessageCurry } from '../utils/api'

export const setPluginsList = (payload) => ({
  type: SET_PLUGINS_LIST,
  payload,
})

export const getPluginsList = (user) => {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      addMessageCurry(getPluginsListAPI(), dispatch)
        .then((list) => {
          resolve(list)
          dispatch(setPluginsList({ list }))
        })
        .catch((err) => console.log(err))
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/plugins.js